module.exports = __webpack_public_path__ + "static/media/10.290b18b1.png";